export default {
	data(){
		return {
			tableGBoptions: { 
				options: {eliminar: 'Eliminar garantia'},
				modals: [
					{
					  "modal": "examen",
					  "icon": "list-check",
					  "title": "Examen de Optometría - Garantía"
					},
				]				
			},

			tableGBSearch: ['datos_pacientes/name','datos_pacientes/documento'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombre Paciente', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Garantia'},
					tbody: { td: ['info_garantia/garantia'],}
				},
				{
					thead: { th: 'Exámen', },
					tbody: { td: ['info_orden/id_info_examens'], link: '/api/pdf/examen' }
				},
				{
					thead: { th: 'Diagnostico', },
					tbody: { td: ['info_orden/id'], link: '/api/pdf/diagnosticos' }
				},
				{
					thead: { th: 'Orden', },
					tbody: { td: ['info_orden/id'], link: '/api/pdf/orden_venta' }
				},
			]
			
		}
	},
}